import { IMessagingService } from "../services";
import { Component } from "./component";

class SearchResults extends Component {
    protected searchResults: HTMLElement;
    protected searchResultsCount: HTMLElement;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        this.searchResults = componentEl;
        this.searchResultsCount = this.searchResults.querySelector(".js-search-results-count");
        this.init();
    }

    protected async init() {
        this.searchResultsCount?.focus();
    }
}

export { SearchResults };